import React from 'react';
import { DefaultLayout } from '../layouts';
import { Route } from "react-router";
import { Redirect } from "react-router-dom";
import { RoutePartnersAllowed } from "./AllowedRoute/RoutePartnersAllowed";

export function RouteWithNavigation(props) {
    const { component: Component, path, auth, child, ...rest } = props;
    const originalRoute =
        <Route exact
             { ...{ ...rest, path } }
             render = {(matchProps) => (
                 <DefaultLayout match={ matchProps.match } auth={auth}>
                     <Component { ...matchProps } child={child}/>
                 </DefaultLayout>
             )}
        />
    ;

    const getRouteAllowed = (auth, path) => {
        const accessToken = auth.getAccessToken();
        // redirect to eracole for authentication
        if (!accessToken) {
            return originalRoute;
        }

        const jwtToken = auth.parseJwt(accessToken);
        // isn't a guest and it's already authenticate
        if (jwtToken.username === undefined) {
            return originalRoute
        }

        return getRouteForGuest(jwtToken, path);
    }

    const getRouteForGuest = (jwtToken, path) => {
        const partnerName = jwtToken.username.replace('partner|', '');
        const routeAllowed = RoutePartnersAllowed().filter((list) => list.partner === partnerName);

        if (!routeAllowed[0].routes.includes(path)) {
            // If route is not allowed redirect on the first allowed route
            return (
                <Redirect to={routeAllowed[0].routes[0]} />
            )
        }

        return originalRoute;
    }

    return getRouteAllowed(auth, path);
}


// WEBPACK FOOTER //
// ./src/router/index.js